document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.PersonaLanding-pages-form-selector').forEach(function (sel) {
        sel.addEventListener('change', function () {
            var personaFormValue = sel.value;
            var form = document.getElementById('personaLandingPagesForm');
            if (form) form.setAttribute('action', personaFormValue);
        });
    });

    // Scroll button handler
    document.querySelectorAll('.scroll-button').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var thisLink = btn;
            var destTop = thisLink.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: destTop, behavior: 'smooth' });
        });
    });

    // data-scroll-element handlers
    document.querySelectorAll('a[data-scroll-element]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var scrollElement = link.getAttribute('data-scroll-element');
            var target = document.querySelector('.' + scrollElement);
            console.log('scrollElement:', scrollElement, 'target:', target);
            if (target) {
                var destTop = target.getBoundingClientRect().top + window.scrollY - 50;
                window.scrollTo({ top: destTop, behavior: 'smooth' });
            }
            else {
                target = document.querySelector('#' + scrollElement);
            console.log('scrollElement:', scrollElement, 'target:', target);
                if (target) {
                    var destTop = target.getBoundingClientRect().top + window.scrollY - 50;
                    window.scrollTo({ top: destTop, behavior: 'smooth' });
                }
            }
        });
    });

    // Collapse shown event (bootstrap)
    document.querySelectorAll('.collapse').forEach(function (el) {
        el.addEventListener('shown.bs.collapse', function () {
            var parent = el.parentElement;
            if (parent) {
                parent.querySelectorAll('.fa-plus').forEach(function (i) { i.classList.remove('fa-plus'); i.classList.add('fa-minus'); });
                parent.querySelectorAll('.fa-minus').forEach(function (i) { i.classList.remove('fa-minus'); i.classList.add('fa-plus'); });
            }
        });
    });

    document.querySelectorAll('.text-more-link, .intro-more-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var prev = link.previousElementSibling;
            if (!prev) return;
            if (prev.classList.contains('active')) {
                prev.classList.remove('active');
                link.innerHTML = '... Read More';
            } else {
                prev.classList.add('active');
                link.innerHTML = 'Read Less';
            }
        });
    });

    // resize handler
    window.addEventListener('resize', function () {
        var openTablePickers = document.querySelectorAll('.ot-dtp-picker');
        for (var i = 0; i < openTablePickers.length; i++) {
            if (window.innerWidth > 1000) {
                openTablePickers[i].classList.remove('standard');
                openTablePickers[i].classList.add('wide');
            } else {
                openTablePickers[i].classList.remove('wide');
                openTablePickers[i].classList.add('standard');
            }
        }
    });

    document.querySelectorAll('.Destinations-menu-link').forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            var wrapper = document.querySelector('.Destinations-menu');
            if (wrapper) wrapper.classList.toggle('active');
        });
    });

});

// ########## Misc Functions ##########

function dateFormatter(date) {
    var d=new Date(date); if (isNaN(d.getTime())) return ''; return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
}

function SoftScrollToAnchor() {
    var hash = window.location.hash.slice(1);
    if (hash) {
        var el = document.getElementById(hash);
        if (el) {
            var top = el.getBoundingClientRect().top + window.scrollY - 110;
            window.scrollTo({ top: top, behavior: 'smooth' });
        }
    }
}

// Read a page's GET URL variables and return them as an associative array.
function GetUrlVars() {
    var vars = [], hash;
    var qIndex = window.location.href.indexOf('?');
    if (qIndex === -1) return vars;
    var hashes = window.location.href.slice(qIndex + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

// Defer Images
var lazy = [];
var lazyBackground = [];

function DeferImages() {
    var viewportWidth = window.innerWidth;

    if (viewportWidth > 1024) {
        for (var i = 0; i < lazy.length; i++) {
            if (lazy[i].getAttribute('data-src') && lazy[i].getAttribute('data-src-deferred') == 'true') {
                lazy[i].setAttribute('src', lazy[i].getAttribute('data-src'));
                lazy[i].removeAttribute('data-src');
                lazy[i].removeAttribute('data-src-mobile');
            }
        }
        for (var i = 0; i < lazyBackground.length; i++) {
            if (lazyBackground[i].getAttribute('data-src-bg-deferred') == 'true') {
                lazyBackground[i].setAttribute('style', lazyBackground[i].getAttribute('data-src-bg'));
                lazyBackground[i].removeAttribute('data-src-bg');
                lazyBackground[i].removeAttribute('data-src-bg-mobile');
            }
        }
        CleanLazy();
    } else {
        for (var i = 0; i < lazy.length; i++) {
            if (lazy[i].getAttribute('data-src-mobile') && lazy[i].getAttribute('data-src-deferred') == 'true') {
                lazy[i].setAttribute('src', lazy[i].getAttribute('data-src-mobile'));
                lazy[i].removeAttribute('data-src');
                lazy[i].removeAttribute('data-src-mobile');
            }
        }
        for (var i = 0; i < lazyBackground.length; i++) {
            if (lazyBackground[i].getAttribute('data-src-bg-deferred') == 'true') {
                // Offer a backup
                if (lazyBackground[i].getAttribute('data-src-bg-mobile') && lazyBackground[i].getAttribute('data-src-bg-mobile').length > 0) {
                    lazyBackground[i].setAttribute('style', lazyBackground[i].getAttribute('data-src-bg-mobile'));
                } else if (lazyBackground[i].getAttribute('data-src-bg') && lazyBackground[i].getAttribute('data-src-bg').length > 0) {
                    lazyBackground[i].setAttribute('style', lazyBackground[i].getAttribute('data-src-bg'));
                }
                lazyBackground[i].removeAttribute('data-src-bg');
                lazyBackground[i].removeAttribute('data-src-bg-mobile');
            }
        }
        CleanLazy();
    }
}

window.onload = function () {
    lazy = document.getElementsByTagName('img');
    lazyBackground = document.querySelectorAll('*[data-src-bg]');

    setTimeout(function () {
        DeferImages();
        SetDeferOnScroll();
    }, 1750);
}

function SetDeferOnScroll() {
    window.addEventListener('scroll', function () { DeferImages(); });
}

function CleanLazy() {
    lazy = Array.prototype.filter.call(lazy, function (l) { return l.getAttribute('data-src'); });
    lazyBackground = Array.prototype.filter.call(lazyBackground, function (l) { return l.getAttribute('data-src-bg'); });
}

// position helper (kept same as previous implementation)
function position(el) {
    if (!el) return { top: 0, left: 0 };
    var rect = el.getBoundingClientRect();
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || document.body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || document.body.scrollLeft;
    var clientTop = docEl.clientTop || document.body.clientTop || 0;
    var clientLeft = docEl.clientLeft || document.body.clientLeft || 0;
    return {
        top: rect.top + scrollTop - clientTop,
        left: rect.left + scrollLeft - clientLeft
    };
}

if (document.querySelector('.meeting-package-snippet-wrap')) {
    window.addEventListener('scroll', function () {
        var wrap = document.querySelector('.meeting-package-snippet-wrap');
        var nav = document.querySelector('.main-navigation-wrapper');
        var snippet = document.querySelector('.meeting-package-snippet');
        if (!wrap || !nav || !snippet) return;
        if (position(wrap).top <= nav.offsetHeight) {
            snippet.classList.add('snapped');
            snippet.style.top = nav.offsetHeight + 'px';
        } else {
            snippet.classList.remove('snapped');
        }
    });
}

// Script to add spacing to the first element after the header, if it is one of the specified types. This is to prevent the header from overlapping content on page load, especially when the header is fixed and the page has a banner or control row at the top. The script runs on DOMContentLoaded and also observes for dynamic content insertion.
(function () {
  const containerIds = ['mainContent', 'main-content'];
  const selector = '.control-row, .restaurant-banner, .spa-banner, .standard-banner, .homepage-banner';
  function getContainer() {
    return containerIds.map(id => document.getElementById(id)).find(el => el);
  }

  function addHeaderSpacing() {
    const container = getContainer();
    if (!container) return false;
    const first = container.querySelector(selector);
    if (first && !first.classList.contains('header-spacing')) {
      first.classList.add('header-spacing');
      return true;
    }
    return false;
  }

  // Run on load (or immediately if already loaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHeaderSpacing);
  } else {
    addHeaderSpacing();
  }

  // Optional: watch for dynamic insertion and stop once we've applied it
  const observerTarget = getContainer();
  if (observerTarget) {
    const observer = new MutationObserver(() => {
      if (addHeaderSpacing()) observer.disconnect();
    });
    observer.observe(observerTarget, { childList: true, subtree: true });
  }
})();
